import { render, staticRenderFns } from "./WaveMoneyTransactionDetail.vue?vue&type=template&id=1376e9ca&scoped=true"
import script from "./WaveMoneyTransactionDetail.vue?vue&type=script&lang=js"
export * from "./WaveMoneyTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1376e9ca",
  null
  
)

export default component.exports